import * as React from 'react';
import { DeprecatedSelect, ISelectOption } from '../../../../../web/components/DeprecatedSelect';
import { styleSheet } from './styles';

interface IProps {
	disabled?: boolean;
	onChange?: (item: string) => void;
	selected?: string;
}

const options: ISelectOption<string>[] = [
	{
		dataContext: null,
		id: 'all',
		text: 'All Channels',
	},
	{
		dataContext: '1',
		id: '1',
		text: 'Rep Only',
	},
	{
		dataContext: '2',
		id: '2',
		text: 'All Parties',
	},
];

export const RecordingChannelsSelect: React.FC<IProps> = ({ disabled, onChange, selected }) => {
	const onClick = (option: ISelectOption<string>) => {
		onChange(option.dataContext);
	};

	const selectedOption = options.find(x => x.dataContext === selected) || options[0];

	return (
		<DeprecatedSelect
			dropdownStyles={[styleSheet.selectDropdown]}
			onOptionClick={onClick}
			options={options}
			disabled={disabled}
			selectedOption={selectedOption}
			styles={[styleSheet.select]}
		/>
	);
};
